export const DEFAULT_CLIENT = 'default';
export const V2_CLIENT = 'v2';

